import { Children, useEffect, useState } from 'react';
import Modal from 'react-modal';
import { CloseIcon, colors, Div, H1, H3 } from 'styles';

interface ModalProps {
  isOpen: boolean;
  setIsOpen: any;
  children?: any;
  title?: string;
  noBackground?: boolean;
}

export const ModalComponent = ({
  children,
  title,
  isOpen,
  setIsOpen,
  noBackground = false,
}: ModalProps) => {
  const customStyles = {
    content: {
      borderRadius: '15px',
      top: '50%',
      left: '50%',
      right: 'auto',
      bottom: 'auto',
      marginRight: '-50%',
      transform: 'translate(-50%, -50%)',
      background: noBackground ? 'none' : '#131111',
      width: '90%',
      maxWidth: '90%',
      border: 'none',
      padding: '0',
    },
    overlay: {
      background: colors.black + 80,
    },
  };

  return (
    <Modal
      isOpen={isOpen}
      onRequestClose={() => setIsOpen(false)}
      style={customStyles}
      ariaHideApp={false}
    >
      <Div $column>
        {!noBackground && (
          <Div
            $flex
            $column
            $alignEnd
            onClick={() => setIsOpen(false)}
            style={{ cursor: 'pointer' }}
          >
            <CloseIcon />
          </Div>
        )}
        <Div $flex $column $center>
          {title && <H3 color={colors.white}>{title}</H3>}
        </Div>
        {children}
      </Div>
    </Modal>
  );
};
